import { IProduct, searchClient } from 'apis/algolia';
import { useQuery } from 'react-query';

import { UseQueryHook } from './types';

const VENDOR_LIST_INDEX = 'vendors_list_v1';

type UseQueryAlgoliaProductsByIdDependencies = {
  product_ids: Array<string>;
};

const getProducts = async ({
  product_ids,
}: UseQueryAlgoliaProductsByIdDependencies): Promise<Array<IProduct>> => {
  const searchResult = await searchClient.multipleGetObjects<IProduct | null>(
    product_ids.map((id) => ({
      objectID: id,
      indexName: VENDOR_LIST_INDEX,
    }))
  );

  // If Algolia can't find some of the given products, it'll put `null` into the
  // array, rather than returning nothing. Let's just filter those missing values
  // out now.
  return searchResult.results.filter(Boolean);
};

const useQueryAlgoliaProductsById: UseQueryHook<
  UseQueryAlgoliaProductsByIdDependencies,
  Array<IProduct>
> = ({ product_ids, enabled }) => {
  const { data, isLoading, refetch } = useQuery(
    ['getAlgoliaProductsById', product_ids],
    () => getProducts({ product_ids }),
    { enabled }
  );

  return {
    data,
    isLoading,
    refetch,
  };
};

export default useQueryAlgoliaProductsById;
